import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgRetailIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M29.46 27.36h.409c1.093 0 1.093 1.64 0 1.64H2.819c-1.092 0-1.092-1.64 0-1.64h.41V10.557a4.08 4.08 0 0 1-.82-2.458V4.82A.82.82 0 0 1 3.23 4h26.23a.82.82 0 0 1 .82.82v3.278c0 .922-.305 1.773-.82 2.458v16.805Zm-1.64 0V11.856a4.098 4.098 0 0 1-4.918-1.298 4.099 4.099 0 0 1-6.558 0 4.1 4.1 0 0 1-6.557 0 4.1 4.1 0 0 1-4.918 1.298V27.36h13.934V15.475a.82.82 0 0 1 .82-.82h6.148a.82.82 0 0 1 .82.82v11.886h1.229ZM4.05 5.64v2.458a2.462 2.462 0 0 0 2.458 2.46 2.462 2.462 0 0 0 2.46-2.46V5.64h-4.92Zm13.114 0v2.458a2.462 2.462 0 0 0 2.46 2.46 2.462 2.462 0 0 0 2.458-2.46V5.64zm6.557 0v2.458a2.462 2.462 0 0 0 2.46 2.46 2.461 2.461 0 0 0 2.458-2.46V5.64zM10.607 8.097a2.461 2.461 0 0 0 2.459 2.46 2.462 2.462 0 0 0 2.459-2.46V5.64h-4.918V8.1Zm9.836 19.263h4.508V16.295h-4.508v11.066ZM6.918 24.49a.82.82 0 0 1-.82-.819v-8.197a.82.82 0 0 1 .82-.82h9.836a.82.82 0 0 1 .82.82v8.197a.82.82 0 0 1-.82.82H6.918Zm9.017-1.639v-6.557H7.738v6.557z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRetailIcon;
